import { useSelector } from 'react-redux';
import { selectVersion, selectVersions } from '../selectors/version';
import type { RootState } from '../types/graph';

export const useVersion = () => {
  return useSelector(selectVersion);
};

export const useSpecialty = () => {
  const version = useSelector(selectVersion);
  const speciality = useSelector(
    (state: RootState) => state.questionnaire.config?.speciality,
  );

  return version && version >= 26.1 ? speciality : undefined;
};

export const useVersions = () => {
  return useSelector(selectVersions);
};
